import {
    FETCH_NEAREST_CENTER_REQUEST,
    FETCH_NEAREST_CENTER_SUCCESS,
    FETCH_NEAREST_CENTER_FAILURE,
  } from '../constants/actionTypes'
  
  const initialState = {}
  export default function interestedCourseReducer(
    state = initialState,
    action = {}
  ) {
    const { type, response } = action
    switch (type) {
      case FETCH_NEAREST_CENTER_REQUEST:
        return {
          ...state,
          loading: true,
        }
      case FETCH_NEAREST_CENTER_SUCCESS: {
        return {
          ...state,
          centerNameList: JSON.parse(response.data),
          loading: false,
        }
      }
      case FETCH_NEAREST_CENTER_FAILURE:
        return {
          ...state,
          loading: false,
        }
  
      default:
        return state
    }
  }